// @flow
import { fromJS, List } from 'immutable';
import type { Map } from 'immutable';
import { GROUP_SIZE } from '~/core/constants/dashboard';
import { range } from 'lodash/fp';

// $FlowFixMe
const emptyDashboardCustomisationMap = (): Map<*, *> => fromJS({ pages: [{ items: [], position: 0 }] });

const productsAsDefaultCustomisation = (products: List<*>): Map<*, *> => {
    if (!products || products.size === 0) {
        return emptyDashboardCustomisationMap();
    }

    const iterations = Math.ceil(products.count() / GROUP_SIZE);
    const productsAsGroups = range(0, iterations).reduce((all, item, i) => {
        const start = i * GROUP_SIZE;
        const end = (i + 1) * GROUP_SIZE;
        return all.push(
            fromJS({
                position: i,
                items: products.slice(start, end).map((p, position) =>
                    fromJS({
                        position,
                        type: 'node',
                        id: p.get('id')
                    })
                )
            })
        );
    }, List());

    // $FlowFixMe
    return fromJS({ pages: productsAsGroups });
};

export default productsAsDefaultCustomisation;



// WEBPACK FOOTER //
// ./src/core/state/dashboard/productsAsDefaultCustomisation.js